import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { supabase } from '../lib/supabaseClient';
import { Button } from './ui/button'; // Assuming path is correct

export default function LogoutButton() {
  const navigate = useNavigate(); // Get navigate function

  const handleLogout = async () => {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
      // Redirect to landing page after successful logout
      navigate('/', { replace: true });
    } catch (error) {
      console.error('Error logging out:', error);
      alert(`Error logging out: ${error.message}`); // Simple error feedback
    }
  };

  return (
    <Button
      onClick={handleLogout}
      className="py-2 px-3 text-white font-semibold rounded-lg bg-gradient-to-r from-purple-500 to-blue-500 hover:from-purple-600 hover:to-blue-600 transition-all duration-300 shadow-lg hover:shadow-xl"
    >
      Logout
    </Button>
  );
}
